/**
 * PanelChrome — shared card wrapper for the 3 disposal BI panels.
 *
 * Phase 16 / Task 16.6 (DEC-163). Standard shadcn Card with a dark-theme
 * title bar + description slot + main content region.
 */
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from 'src/components/ui/card';

interface PanelChromeProps {
  readonly title: string;
  readonly description?: string;
  readonly actions?: React.ReactNode;
  readonly children: React.ReactNode;
}

export function PanelChrome({
  title,
  description,
  actions,
  children,
}: PanelChromeProps): React.JSX.Element {
  return (
    <Card className="border-border bg-card">
      <CardHeader className="flex flex-row items-center justify-between space-y-0">
        <div>
          <CardTitle className="text-foreground">{title}</CardTitle>
          {description !== undefined && (
            <CardDescription className="text-[var(--color-text-tertiary)]">
              {description}
            </CardDescription>
          )}
        </div>
        {actions}
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  );
}
